import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faCheck, faEyeSlash, faEye } from '@fortawesome/free-solid-svg-icons';
import apiClient from "../../axios";
import LoginNotification from "../Notifications/LoginNotification";
import Loader from "../Loader";
import SuccessProcess from '../Notifications/SuccessProcess';

const AddElectronicSignature = ({ isVisible, onClose, ruc, client,edit }) => {
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);
    const [password, setPassword] = useState("");
    const [confirmarClave, setConfirmarClave] = useState("");
    const [errors, setErrors] = useState({});
    const [isLoginVisible, setIsLoginVisible] = useState(false);
    const miBaseURL = apiClient.defaults.baseURL;
    const token = localStorage.getItem('token');
    const [successVisible, setSuccessVisible] = useState(false);
    const [messageBlock, setMessageBlock] = useState("");
    const [notificationBlock, SetNotificationBlock] = useState(false);
    const [gemaId, setGemaId] = useState(false);

    useEffect(() => {
        if (edit) {
            const fetchProduct = async () => {
                try {
                    const response = await apiClient.get(`/admin/companies?search=${ruc}`);
                    setGemaId(response.data[0].gemaId);
                } catch (error) {
                    console.error("Error al cargar el Compania", error);
                }
            };
            fetchProduct();
        }
    }, [edit, ruc]);

    const handleFileChange = (event) => {
        setFile(event.target.files[0]); // Guarda el archivo en el estado
    };

    const toggleShowPassword = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    const toggleShowPassword2 = () => {
        setShowPassword2((prevShowPassword) => !prevShowPassword);
    };


    const validateFields = () => {
        let validationErrors = {};
        if (!password) validationErrors.password = "El Campo es Obligatorio";
        if (password !== confirmarClave) {
            validationErrors.confirmarClave = "Las claves no coinciden";
        }
        if (!file) {
            validationErrors.file = "El Campo es Obligatorio";
        } else {
            const validExtensions = [".p12", ".pfx", ".p2"];
            const fileExtension = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();
            if (!validExtensions.includes(fileExtension)) {
                validationErrors.file = "El archivo debe ser una Firma Electrónica válida (.p12, .pfx, .p2).";
            }
        }

        return validationErrors;
    };

    const handleCloseSuccess = () => {
        setSuccessVisible(false);
        onClose();
    };

    const handleCloseBlock = () => {
        SetNotificationBlock(false);

    };

    const handleSave = async () => {
        const validationErrors = validateFields();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        try {
            setLoading(true);
            if (edit) {
                const formData = new FormData();
                formData.append('digitalCert', file);
                formData.append('password', password);
                const response = await fetch(`${miBaseURL}/gema/company/${gemaId}`, {
                    method: 'PATCH',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                    body: formData,
                });
                const data = await response.json();
                if (response.status === 201) {
                    setSuccessVisible(true);
                } else if (response.status === 400) {
                    if (data?.message?.startsWith("COMPANY_NOT_FOUND")) {
                        setMessageBlock(`No se puede registrar la Firma Electrónica debido a:
                                La compania no existe.`)
                        SetNotificationBlock(true);
                    } else if (data?.message?.startsWith("Company With This Ruc Already Exist")) {
                        setMessageBlock(`No se puede registrar la Firma Electrónica debido a:
                                El RUC ya tiene un certificado asociado.`)
                        SetNotificationBlock(true);
                    } else if (data?.message?.startsWith("Invalid Digital Certificate Password")) {
                        setMessageBlock(`No se puede registrar la Firma Electrónica debido a:
                                La clave ingresada es Incorrecta.`)
                        SetNotificationBlock(true);
                    } else if (data?.message?.startsWith("\"ruc\" length must be 13 characters long")) {
                        setMessageBlock(`No se puede registrar la Firma Electrónica debido a:
                                El RUC debe tener 13 caracteres.`)
                        SetNotificationBlock(true);
                    }
                } else if (response.status === 401) {
                    setIsLoginVisible(true);
                }
            }
            else {
                const formData = new FormData();
                formData.append('digitalCert', file);
                formData.append('client', client);
                formData.append('ruc', ruc);
                formData.append('password', password);
                const response = await fetch(`${miBaseURL}/gema/company`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`, // Agrega el token de autenticación
                    },
                    body: formData,
                });
                const data = await response.json();
                if (response.status === 201) {
                    setSuccessVisible(true);
                } else if (response.status === 400) {
                    if (data?.message?.startsWith("COMPANY_NOT_FOUND")) {
                        setMessageBlock(`No se puede registrar la Firma Electrónica debido a:
                                La compania no existe.`)
                        SetNotificationBlock(true);
                    } else if (data?.message?.startsWith("Company With This Ruc Already Exist")) {
                        setMessageBlock(`No se puede registrar la Firma Electrónica debido a:
                                El RUC ya tiene un certificado asociado.`)
                        SetNotificationBlock(true);
                    } else if (data?.message?.startsWith("Invalid Digital Certificate Password")) {
                        setMessageBlock(`No se puede registrar la Firma Electrónica debido a:
                                La clave ingresada es Incorrecta.`)
                        SetNotificationBlock(true);
                    }
                } else if (response.status === 401) {
                    setIsLoginVisible(true);
                }
            }

        } catch (error) {
            if (error.response && error.response.status === 401) {
                setIsLoginVisible(true);
            }
        }
        finally {
            setLoading(false);
        }

    };



    return (
        isVisible && (
            <div className="modal-overlay">
                <div className="info-notification-info2">
                    <div className="modal-content-module-body">
                        <div className="message-container-info">
                            <h3 className="basic-info-form-title">Registro de Firma Electrónica | CLIENTE: {client} | RUC: {ruc}</h3>
                        </div>
                        <div className="basic-info-form-grid">
                            <div className="basic-info-form-group">
                                <label style={{ color: errors.file ? "red" : "revert-layer" }} htmlFor="file">
                                    Subir Firma Electrónica
                                </label>
                                <input type="file" onChange={handleFileChange} />
                                <p className="error-message">{errors.file}</p>
                            </div>
                            <div className="basic-info-form-group">
                                <label style={{ color: errors.password ? "red" : "revert-layer" }}>
                                    Clave
                                </label>
                                <div className="password-input-container">
                                    <input
                                        className="text-box-login2"
                                        type={showPassword ? "text" : "password"}
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="Contraseña"
                                    />
                                    <FontAwesomeIcon
                                        icon={showPassword ? faEyeSlash : faEye}
                                        className="password-toggle-icon2"
                                        onClick={toggleShowPassword}
                                    />
                                </div>
                                {errors.password && <p className="error-message">{errors.password}</p>}
                            </div>
                            <div className="basic-info-form-group">
                                <label style={{ color: errors.confirmarClave ? "red" : "revert-layer" }}>
                                    Confirmar Clave
                                </label>
                                <div className="password-input-container">
                                    <input
                                        className="text-box-login2"
                                        type={showPassword2 ? "text" : "password"}
                                        placeholder="Confirmar Clave"
                                        value={confirmarClave}
                                        onChange={(e) => setConfirmarClave(e.target.value)}
                                    />
                                    <FontAwesomeIcon
                                        icon={showPassword2 ? faEyeSlash : faEye}
                                        className="password-toggle-icon2"
                                        onClick={toggleShowPassword2}
                                    />
                                </div>
                                {errors.confirmarClave && <p className="error-message">{errors.confirmarClave}</p>}
                            </div>

                        </div>

                    </div>
                    <div className="basic-form-footer">
                        <button className="basic-custom-button" onClick={onClose}>
                            <FontAwesomeIcon icon={faXmark} className="basic-shortcut-icon" />
                            Cancelar
                        </button>
                        <button className="basic-custom-button" onClick={handleSave}  >
                            <FontAwesomeIcon icon={faCheck} className="basic-shortcut-icon" />
                            Aceptar
                        </button>
                    </div>
                </div>
                {loading && <Loader />}
                <LoginNotification
                    message="Vuele a iniciar sesión"
                    isVisible={isLoginVisible}
                    onClose={() => setIsLoginVisible(false)}
                />
                <SuccessProcess
                    message={"Se ha registrado el Certificado correctamente."}
                    isVisible={successVisible}
                    onClose={handleCloseSuccess}
                    redirectOnOk={false}
                    whatsApp={false}
                />
                {notificationBlock && (
                    <SuccessProcess
                        enca={true}
                        message={messageBlock}
                        isVisible={notificationBlock}
                        onClose={handleCloseBlock}
                        redirectOnOk={false}
                        whatsApp={false}
                    />
                )}
            </div>
        )
    );
};

export default AddElectronicSignature;
